import AnimationClip from '../AnimationClip';
import GameObject from '../../../GameObject/GameObject';
import { Easing } from '@tweenjs/tween.js';
import { AwaitIterators } from '../AnimationHelper';
import ElementComponent from '../../../Component/UI/Element';
import Renderable from '../../../Component/Renderable';
import Point from '../../../Utility/Point';
import TransformComponent from '../../../Component/Transform';
import SpriteComponent from '../../../Component/Render/Sprite';
import TextComponent from 'Component/Render/Text';

export class UIPopOut extends AnimationClip {
    public *execute(
        gameObject: GameObject,
        meta?: any
    ): IterableIterator<number> {
        meta = meta || {};
        const renderable = gameObject.hasComponent(Renderable)
            ? gameObject.getComponent(Renderable)
            : gameObject.hasComponent(SpriteComponent) ? gameObject.getComponent(SpriteComponent)
            : gameObject.hasComponent(TextComponent) ? gameObject.getComponent(TextComponent) : null;

        if (renderable === null) return;

        renderable.visible = true;
        renderable.alpha = meta.startAlpha || 1;

        let element: ElementComponent | TransformComponent;
        if (gameObject.hasComponent(ElementComponent)) {
            element = gameObject.getComponent(ElementComponent);
        } else if (gameObject.hasComponent(TransformComponent)) {
            element = gameObject.getComponent(TransformComponent);
        }
        element.scale.copy(Point.One);

        const scaleTween = this.getTween(element.scale);
        const alphaTween = this.getTween(renderable);

        alphaTween.to({ alpha: 0 }, 150).easing(Easing.Linear.None);
        scaleTween.to({ x: 0, y: 0 }, 600).easing(Easing.Elastic.Out);

        yield* AwaitIterators([
            this.startTween(scaleTween),
            this.startTween(alphaTween),
        ]);

        renderable.visible = false;
    }
}
